import Link from "next/link";

import { routes } from "src/shared/routes";
import { createJsxLink } from "src/utils/create-jsx-link";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Exclusive Kings Upgrades",
    description:
      "Season Ticket Members can upgrade their upper level seat to the lower level for select games, while supplies last. Registration required upon first time log in.",
    buttonLabel: "View Offers",
    authRedirectPage: routes.home,
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "Why don't I see seat upgrades available to purchase?",
    answer:
      "Seat upgrades are only available to Upper Bowl Season Ticket Members.",
  },
  {
    question: "Will seat upgrades be available for every game?",
    answer:
      "Upgrades are not guaranteed for every game. Availability depends on inventory and may vary. Please check back on game day to see the upgrade options available to you.",
  },
  {
    question: "Where will I find my upgraded tickets?",
    answer:
      "After your purchase is complete, your upgraded tickets will be delivered directly into your Sacramento Kings Account Manager.",
  },
  {
    question: "Where will my upgraded seats be located?",
    answer:
      "Your upgraded seats will be located in the section(s) noted within the specific seat upgrade offer at the time of purchase.",
  },
  {
    question: "Can I transfer my upgraded tickets to someone else?",
    answer:
      "No. Seat upgrades are non-transferable and are not eligible for resale.",
  },
  {
    question: "Can I change my seats after purchasing an upgrade?",
    answer:
      "Once your upgraded tickets are delivered to your account, they cannot be changed. If you need assistance, please visit Ticket Resolution for support.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link href="https://www.attend.tech/terms-of-use" target="_blank">
      Terms of Use
    </Link>{" "}
    &{" "}
    <Link href="https://www.attend.tech/privacy-policy" target="_blank">
      Privacy Policy
    </Link>
    .
  </>
);

export const ADD_ON_PURCHASE_SUCCESS_MESSAGE = {
  TITLE: () => <>You&apos;re all set to experience the action!</>,
  DESCRIPTION: () => (
    <>
      View your tickets{" "}
      <b>
        <u>
          <Link
            target="_blank"
            style={{
              color: "white",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            href="https://am.ticketmaster.com/sackings/"
          >
            here
          </Link>
        </u>
      </b>
      .
    </>
  ),
};

export const REGISTRATION_TERMS_AND_CONDITIONS = () => (
  <>
    By checking this box you agree to receive notifications from the Sacramento
    Kings and agree to the{" "}
    {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")} and{" "}
    {createJsxLink("Privacy Policy", "https://www.attend.tech/privacy-policy")}.
  </>
);
